/* Package PDP (2026-10-15): keep the turf choice when a shopper switches size or protection,
   and show the matching turf in "In the package". Links carry data-nr-variant-map:
   { "<option1>": [variantId, "<formatted price>"] }. */
(function () {
  if (window.nrPackageSetup) return;
  window.nrPackageSetup = true;

  function sync(option) {
    if (!option) return;
    document.querySelectorAll('[data-nr-variant-map]').forEach(function (link) {
      var map;
      try { map = JSON.parse(link.getAttribute('data-nr-variant-map')); } catch (e) { return; }
      var hit = map[option];
      if (!hit) return;
      link.href = link.getAttribute('data-nr-base-url') + '?variant=' + hit[0];
      var price = link.querySelector('[data-nr-variant-price]');
      if (price && hit[1]) price.textContent = hit[1];
    });
    document.querySelectorAll('[data-nr-turf-row]').forEach(function (row) {
      row.hidden = row.getAttribute('data-nr-turf-row') !== option;
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant) sync(variant.option1);
  });
})();
